import React from "react";
import { Star, ExternalLink } from "lucide-react";
import { motion } from "framer-motion";
import { GOOGLE_REVIEWS } from "@/constants/content";

export default function GoogleReviews() {
  return (
    <section className="section bg-white" data-testid="google-reviews-section">
      <div className="container-page">
        <div className="rounded-3xl border border-slate-200/70 bg-gradient-to-br from-white to-[#F8FAFC] p-6 md:p-10 lg:p-14 grid lg:grid-cols-2 gap-8 lg:gap-14 items-center">
          <div>
            <div className="eyebrow mb-3">
              <span className="inline-flex items-center gap-1 rounded-full bg-white border border-slate-200 px-2 py-1">
                <svg className="h-3 w-3" viewBox="0 0 48 48"><path fill="#EA4335" d="M24 9.5c3.5 0 6.6 1.2 9.1 3.5l6.8-6.8C35.9 2.4 30.3 0 24 0 14.6 0 6.5 5.4 2.6 13.2l7.9 6.1C12.4 13.5 17.7 9.5 24 9.5z"/><path fill="#4285F4" d="M46.9 24.5c0-1.6-.1-3.1-.4-4.5H24v9h12.9c-.6 3-2.3 5.5-4.9 7.2l7.6 5.9c4.4-4.1 7-10.1 7-17.6z"/><path fill="#FBBC05" d="M10.5 28.7c-.5-1.4-.8-3-.8-4.7s.3-3.3.8-4.7l-7.9-6.1C1 16.6 0 20.2 0 24s1 7.4 2.6 10.8l7.9-6.1z"/><path fill="#34A853" d="M24 48c6.5 0 12-2.1 16-5.8l-7.6-5.9c-2.1 1.4-4.8 2.2-8.4 2.2-6.3 0-11.6-4-13.5-9.7l-7.9 6.1C6.5 42.6 14.6 48 24 48z"/></svg>
                Google Reviews
              </span>
            </div>
            <h2 className="font-display font-bold text-slate-900 text-3xl md:text-4xl lg:text-5xl tracking-tight">
              <span className="bg-gradient-to-r from-[#0A84FF] to-[#10B981] bg-clip-text text-transparent">{GOOGLE_REVIEWS.averageRating}★</span> from {GOOGLE_REVIEWS.totalReviews}+ patients
            </h2>
            <p className="mt-4 text-slate-600 max-w-lg">
              We're humbled by every family that trusted us with their loved one. Read what patients across Delhi NCR say about KinFlex — and share your own experience.
            </p>
            <a
              href={GOOGLE_REVIEWS.reviewUrl}
              target="_blank"
              rel="noreferrer"
              className="mt-6 inline-flex items-center gap-2 rounded-full bg-slate-900 hover:bg-slate-800 text-white px-6 py-3 text-sm font-semibold shadow-md hover:shadow-lg transition-all"
              data-testid="leave-google-review-btn"
            >
              Leave a Google Review <ExternalLink className="h-4 w-4" />
            </a>
          </div>

          <div className="space-y-4">
            {GOOGLE_REVIEWS.highlights.map((r, i) => (
              <motion.div
                key={i}
                initial={{ opacity: 0, x: 20 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.4, delay: i * 0.1 }}
                className="rounded-2xl bg-white border border-slate-200/70 p-5 shadow-sm"
                data-testid={`google-review-${i}`}
              >
                <div className="flex items-center gap-1.5 mb-2">
                  {Array.from({ length: r.rating }).map((_, s) => (
                    <Star key={s} className="h-4 w-4 fill-amber-400 text-amber-400" />
                  ))}
                  <span className="text-xs text-slate-500 ml-1">via Google</span>
                </div>
                <p className="text-sm text-slate-700 leading-relaxed">"{r.text}"</p>
                <div className="mt-3 text-xs font-semibold text-slate-600">— {r.name}</div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
